import LocalStorage from '@/services/localstorage';
// state
const state = {
  language: LocalStorage.getLanguage(),
  homepageBanner: {},
  homepageFeature: {},
  homepageTestimoni: {},
  homepagePartner: {},
};

export default state;
